import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=6514df3f"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6514df3f')) {
      api.createRecord('6514df3f', component.options)
    } else {
      api.reload('6514df3f', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=6514df3f", function () {
      api.rerender('6514df3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Folder/Breadcrumbs.vue"
export default component.exports